import { Card, Col, Row } from "react-bootstrap";
import { IChangeRequestDetails } from "../../../api/IChangeRequests";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { AmendmentIcon } from "../../../leap-components/icons/LeapIcons";

interface ChangeRequestHeaderProps {
  changeRequestDetails: IChangeRequestDetails;
}

const ChangeRequestHeader = ({
  changeRequestDetails,
}: ChangeRequestHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <AmendmentIcon />
                  </td>
                  <td>
                    <h2>
                      Authorisation Amendment: {changeRequestDetails.casenumber}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Status"}
              value={changeRequestDetails.status}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ChangeRequestHeader;
